<template>
  <h1>NotFound</h1>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
